(function () {
    function initSunStations(container) {
        var tablist = container.querySelector('[data-sun-stations-tablist]');
        var tabs = Array.prototype.slice.call(
            container.querySelectorAll('[data-sun-stations-tab]')
        );
        var panels = Array.prototype.slice.call(
            container.querySelectorAll('[data-sun-stations-panel]')
        );
        var indicator = tablist
            ? tablist.querySelector('.archive-filter__indicator')
            : null;

        function moveIndicator(activeTab, shouldAnimate) {
            if (!tablist || !indicator || !activeTab) return;

            var targetWidth = activeTab.offsetWidth;
            var targetX = activeTab.offsetLeft;
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var canUseGsap = typeof window.gsap !== 'undefined';

            tablist.style.setProperty('--indicator-width', targetWidth);
            tablist.style.setProperty('--indicator-x', targetX);

            if (!canUseGsap) return;

            tablist.classList.add('is-gsap');
            window.gsap.killTweensOf(indicator);

            if (!shouldAnimate || reducedMotion) {
                window.gsap.set(indicator, {
                    x: targetX,
                    width: targetWidth,
                    scaleY: 1,
                    borderRadius: '50px'
                });
                return;
            }

            var currentX = Number(window.gsap.getProperty(indicator, 'x')) || 0;
            var distance = targetX - currentX;
            var direction = distance >= 0 ? 1 : -1;
            var stretch = Math.min(Math.max(Math.abs(distance) * 0.14, 14), 40);

            window.gsap.timeline()
                .to(indicator, {
                    x: currentX + distance * 0.46 - (direction < 0 ? stretch : 0),
                    width: targetWidth + stretch,
                    scaleY: 0.86,
                    duration: Math.min(0.32, 0.16 + Math.abs(distance) / 1400),
                    ease: 'power2.in'
                })
                .to(indicator, {
                    x: targetX,
                    width: targetWidth,
                    scaleY: 1,
                    borderRadius: '50px',
                    duration: 0.42,
                    ease: 'elastic.out(1, 0.72)'
                });
        }

        function activateTab(activeTab, moveFocus) {
            var panelId = activeTab.getAttribute('aria-controls');
            var activePanel = null;

            tabs.forEach(function (tab) {
                var isActive = tab === activeTab;
                tab.classList.toggle('is-active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            panels.forEach(function (panel) {
                panel.hidden = panel.id !== panelId;
                if (panel.id === panelId) activePanel = panel;
            });

            moveIndicator(activeTab, true);

            if (
                activePanel
                && typeof window.gsap !== 'undefined'
                && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ) {
                window.gsap.killTweensOf(activePanel);
                window.gsap.fromTo(
                    activePanel,
                    { opacity: 0, y: 8 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.42,
                        ease: 'power3.out',
                        clearProps: 'opacity,transform'
                    }
                );
            }

            if (moveFocus) activeTab.focus();
        }

        function updateRange(range, shouldAnimate) {
            var panel = range.closest('[data-sun-stations-panel]');
            var control = range.closest('.sun-stations__range-control');
            var link = panel ? panel.querySelector('[data-sun-stations-link]') : null;
            var stations = [];

            try {
                stations = JSON.parse(range.dataset.stations || '[]');
            } catch (error) {
                stations = [];
            }

            var currentValue = Number(range.getAttribute('aria-valuenow')) || 0;
            var index = Math.max(0, Math.min(currentValue, stations.length - 1));
            var previousIndex = Number(range.dataset.currentIndex);
            var direction = Number.isFinite(previousIndex) && index < previousIndex
                ? -1
                : 1;
            var station = stations[index];
            var denominator = Math.max(stations.length - 1, 1);
            var progress = index / denominator;
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var canAnimate = shouldAnimate
                && !reducedMotion
                && typeof window.gsap !== 'undefined';

            range.dataset.currentIndex = index;

            if (control) {
                if (canAnimate) {
                    window.gsap.killTweensOf(control);
                    window.gsap.to(control, {
                        '--range-progress': progress,
                        duration: 0.38,
                        ease: 'power2.out'
                    });
                } else {
                    control.style.setProperty('--range-progress', progress);
                }
            }

            if (!station || !link) return;

            link.href = station.url;
            range.setAttribute('aria-valuetext', station.label);
            var currentValue = control
                ? control.querySelector('.sun-stations__current-value')
                : null;
            var currentValueText = currentValue
                ? currentValue.querySelector('[data-sun-stations-current]')
                : null;

            if (currentValue && currentValue.dataset.currentLabel !== station.label) {
                currentValue.dataset.currentLabel = station.label;

                var updateCurrentValue = function () {
                    if (currentValueText) {
                        currentValueText.textContent = station.label;
                    }
                };

                if (canAnimate && currentValueText) {
                    if (currentValue.sunStationsTextTimeline) {
                        currentValue.sunStationsTextTimeline.kill();
                    }

                    currentValue.sunStationsTextTimeline = window.gsap.timeline({
                        onComplete: function () {
                            currentValue.sunStationsTextTimeline = null;
                        }
                    })
                        .to(currentValueText, {
                            xPercent: direction * -110,
                            duration: 0.18,
                            ease: 'power2.in'
                        })
                        .add(updateCurrentValue)
                        .set(currentValueText, { xPercent: direction * 110 })
                        .to(currentValueText, {
                            xPercent: 0,
                            duration: 0.28,
                            ease: 'power3.out',
                            clearProps: 'transform'
                        });
                } else {
                    updateCurrentValue();
                }
            }

            link.setAttribute(
                'aria-label',
                (link.dataset.labelPrefix || 'Детальніше') + ': ' + station.label
            );
        }

        if (tablist && tabs.length) {
            tablist.classList.add('is-enhanced');

            tabs.forEach(function (tab, index) {
                tab.addEventListener('click', function () {
                    if (tab.getAttribute('aria-selected') !== 'true') {
                        activateTab(tab, false);
                    }
                });

                tab.addEventListener('keydown', function (event) {
                    var nextIndex = index;

                    if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
                    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
                    if (event.key === 'Home') nextIndex = 0;
                    if (event.key === 'End') nextIndex = tabs.length - 1;

                    if (nextIndex === index) return;

                    event.preventDefault();
                    activateTab(tabs[nextIndex], true);
                });
            });

            moveIndicator(tabs[0], false);

            window.addEventListener('resize', function () {
                var activeTab = tabs.find(function (tab) {
                    return tab.getAttribute('aria-selected') === 'true';
                }) || tabs[0];

                moveIndicator(activeTab, false);
            });

            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function () {
                    var activeTab = tabs.find(function (tab) {
                        return tab.getAttribute('aria-selected') === 'true';
                    }) || tabs[0];

                    moveIndicator(activeTab, false);
                });
            }
        }

        container.querySelectorAll('[data-sun-stations-range]').forEach(function (range) {
            var stations = [];

            try {
                stations = JSON.parse(range.dataset.stations || '[]');
            } catch (error) {
                stations = [];
            }

            function setIndex(index, shouldAnimate) {
                if (!stations.length) return;

                var nextIndex = Math.max(0, Math.min(index, stations.length - 1));
                range.setAttribute('aria-valuenow', nextIndex);
                updateRange(range, shouldAnimate);
            }

            function setIndexFromPointer(event) {
                if (range.getAttribute('aria-disabled') === 'true') return;

                var bounds = range.getBoundingClientRect();
                var thumbCenter = 32;
                var availableWidth = Math.max(bounds.width - 64, 1);
                var position = Math.max(
                    0,
                    Math.min(event.clientX - bounds.left - thumbCenter, availableWidth)
                );
                var index = Math.round(
                    position / availableWidth * (stations.length - 1)
                );

                setIndex(index, true);
            }

            range.addEventListener('pointerdown', function (event) {
                if (range.getAttribute('aria-disabled') === 'true') return;

                event.preventDefault();
                range.setPointerCapture(event.pointerId);
                setIndexFromPointer(event);
            });

            range.addEventListener('pointermove', function (event) {
                if (!range.hasPointerCapture(event.pointerId)) return;

                setIndexFromPointer(event);
            });

            range.addEventListener('pointerup', function (event) {
                if (range.hasPointerCapture(event.pointerId)) {
                    range.releasePointerCapture(event.pointerId);
                }
            });

            range.addEventListener('keydown', function (event) {
                var currentIndex = Number(range.getAttribute('aria-valuenow')) || 0;
                var nextIndex = currentIndex;

                if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
                    nextIndex += 1;
                }
                if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
                    nextIndex -= 1;
                }
                if (event.key === 'Home') nextIndex = 0;
                if (event.key === 'End') nextIndex = stations.length - 1;

                if (nextIndex === currentIndex) return;

                event.preventDefault();
                setIndex(nextIndex, true);
            });

            updateRange(range, false);
        });
    }

    function init() {
        document.querySelectorAll('[data-sun-stations]').forEach(initSunStations);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
